import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { ModalConsultaRegistroComponent } from './modal/modal-consulta-registro/modal-consulta-registro.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { LoginComponent } from './login/login.component';
import { ModalCadastroContadorComponent } from './modal/modal-cadastro-contador/modal-cadastro-contador.component';
import { NgxMaskModule } from 'ngx-mask';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ModalConfirmaExContadorComponent } from './modal/modal-confirma-ex-contador/modal-confirma-ex-contador.component';
import { ModalConfirmaLimparCamposComponent } from './modal/modal-confirma-limpar-campos/modal-confirma-limpar-campos.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from '../core/header/header.component';
import { SidebarComponent } from '../core/sidebar/sidebar.component';
import { ModalExibirContadorComponent } from './modal/modal-exibir-contador/modal-exibir-contador.component';
import { ModalEditarContadorComponent } from './modal/modal-editar-contador/modal-editar-contador.component';
import { ModalRegistroJucespComponent } from './modal/modal-registro-jucesp/modal-registro-jucesp.component';
import { ModalLogoutComponent } from './modal/modal-logout/modal-logout.component';
import { ModalInformativoJucespComponent } from './modal/modal-informativo-jucesp/modal-informativo-jucesp.component';
import { ModalSelecaoDBEComponent } from './modal/modal-selecao-dbe/modal-selecao-dbe.component';

@NgModule({
  declarations: [
    SharedComponent, 
    ModalConsultaRegistroComponent, 
    LoginComponent,
    ModalCadastroContadorComponent, 
    ModalConfirmaExContadorComponent, 
    ModalConfirmaLimparCamposComponent, 
    ModalExibirContadorComponent, 
    ModalEditarContadorComponent, 
    ModalRegistroJucespComponent,
    ModalLogoutComponent,
    ModalInformativoJucespComponent,
    ModalSelecaoDBEComponent
  ],
  imports: [
    CommonModule,
    MDBBootstrapModule,
    NgxMaskModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    ModalInformativoJucespComponent
  ]

})
export class SharedModule { }
